import { render } from "./TariffsIndividualEdit.vue?vue&type=template&id=35359432&scoped=true&ts=true"
import script from "./TariffsIndividualEdit.vue?vue&type=script&lang=ts"
export * from "./TariffsIndividualEdit.vue?vue&type=script&lang=ts"

import "./TariffsIndividualEdit.vue?vue&type=style&index=0&id=35359432&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35359432"]])

export default __exports__